import React, {PropsWithChildren} from 'react';

const style = {
	row: `flex flex-row gap-x-2 recommended:gap-x-4 justify-between   w-full max-h-96 recommended:max-h-[36rem]`,
};

export const PrimaryContentRow = ({children}: PropsWithChildren) => {
	return <div className={style.row}>{children}</div>;
};
